(function () {
  var MAILCHIMP_POST_JSON =
    'https://furiden.us11.list-manage.com/subscribe/post-json';

  /** 选这两项时禁止通过本表单提交，仅显示邮件说明 */
  var BLOCKED_SUBMIT_CHANNELS = {
    'Beta testers / Invited users': true,
    'Gifts from others': true,
  };

  var ORDER_ID_RULES = {
    Amazon: {
      test: function (v) {
        return /^\d{3}-\d{7}-\d{7}$/.test(v.trim());
      },
      message:
        'Invalid Amazon Order ID format. Please enter a valid ID in the format: XXX-XXXXXXX-XXXXXXX',
    },
    TikTok: {
      test: function (v) {
        return /^\d{18}$/.test(v.trim());
      },
      message:
        'Invalid TikTok ID format. Please enter a valid ID in the format: XXXXXXXXXXXXXXXXXX',
    },
    'FURIDEN Website': {
      test: function (v) {
        return /^#F[A-Za-z0-9]{7}-[A-Za-z]$/.test(v.trim());
      },
      message:
        'Invalid FURIDEN Website ID format. Please enter a valid ID in the format: #Fxxxxxxx-H',
    },
  };

  function isBlockedSubmitChannel(channel) {
    return !!BLOCKED_SUBMIT_CHANNELS[channel];
  }

  /** 亚马逊：仅保留数字，最多 17 位，自动插入 - 为 XXX-XXXXXXX-XXXXXXX */
  function formatAmazonOrderId(value) {
    var digits = String(value).replace(/\D/g, '').slice(0, 17);
    if (digits.length === 0) return '';
    if (digits.length <= 3) return digits;
    if (digits.length <= 10) {
      return digits.slice(0, 3) + '-' + digits.slice(3);
    }
    return digits.slice(0, 3) + '-' + digits.slice(3, 10) + '-' + digits.slice(10);
  }

  /**
   * FURIDEN：补全 #F、末尾 -H（缺省时）；格式 #F + 7 位字母数字 + - + 1 位字母
   */
  function normalizeFuridenOrderId(raw) {
    var s = String(raw).trim().replace(/\s/g, '');
    if (!s) return '';
    if (/^#f[A-Za-z0-9]{7}-[A-Za-z]$/i.test(s)) {
      return '#F' + s.slice(2, 9) + '-' + s.slice(-1);
    }
    if (!/^#F/i.test(s)) {
      if (/^F[A-Za-z0-9]/.test(s)) s = '#' + s;
      else s = '#F' + s;
    } else {
      s = '#F' + s.slice(2);
    }
    var rest = s.slice(2);
    var dash = rest.indexOf('-');
    if (dash === -1) {
      var midOnly = rest.replace(/[^A-Za-z0-9]/g, '').slice(0, 7);
      if (midOnly.length === 7) return '#F' + midOnly + '-H';
      return '#F' + midOnly;
    }
    var middle = rest
      .slice(0, dash)
      .replace(/[^A-Za-z0-9]/g, '')
      .slice(0, 7);
    var tail = rest.slice(dash + 1).replace(/[^A-Za-z0-9]/g, '');
    if (middle.length === 7 && tail.length === 0) return '#F' + middle + '-H';
    if (middle.length === 7 && tail.length >= 1) {
      return '#F' + middle + '-' + tail.charAt(0);
    }
    return '#F' + middle + (tail ? '-' + tail.charAt(0) : '');
  }

  function init() {
    var form = document.querySelector('.register-warranty-form-container form');
    if (!form) return;

    var purchaseSelect = document.getElementById('purchase-from');
    var productGroup = document.getElementById('product-field-group');
    var productSelect = document.getElementById('product');
    var orderInput = document.getElementById('order-id');
    var orderError = document.getElementById('order-id-error');
    var orderOptionalLabel = document.getElementById('order-id-optional-label');
    var orderRequiredMark = document.getElementById('order-id-required-mark');
    var blockedHint = document.getElementById('purchase-channel-blocked-hint');
    var orderGroup = document.getElementById('order-id-group');
    var feedback = document.getElementById('rwf-form-feedback');
    var submitBtn = form.querySelector('.rwf-submit');

    if (!purchaseSelect || !productGroup || !productSelect || !orderInput) return;

    function setProductVisible(show) {
      if (show) {
        productGroup.removeAttribute('hidden');
        productSelect.setAttribute('required', 'required');
      } else {
        productGroup.setAttribute('hidden', '');
        productSelect.removeAttribute('required');
        productSelect.value = '';
      }
    }

    function setOrderFieldState() {
      var channel = purchaseSelect.value;
      if (orderOptionalLabel) {
        orderOptionalLabel.setAttribute('hidden', '');
      }
      if (orderRequiredMark) {
        if (!channel || !ORDER_ID_RULES[channel]) {
          orderRequiredMark.setAttribute('hidden', '');
        } else {
          orderRequiredMark.removeAttribute('hidden');
        }
      }
      orderInput.removeAttribute('required');
    }

    function syncPurchaseChannelUi() {
      var channel = purchaseSelect.value;
      clearOrderError();
      orderInput.value = '';

      if (isBlockedSubmitChannel(channel)) {
        if (blockedHint) blockedHint.removeAttribute('hidden');
        if (submitBtn) submitBtn.disabled = true;
        productGroup.setAttribute('hidden', '');
        productSelect.removeAttribute('required');
        productSelect.value = '';
        if (orderGroup) orderGroup.setAttribute('hidden', '');
        if (orderOptionalLabel) orderOptionalLabel.setAttribute('hidden', '');
        if (orderRequiredMark) orderRequiredMark.setAttribute('hidden', '');
        orderInput.removeAttribute('required');
        return;
      }

      if (blockedHint) blockedHint.setAttribute('hidden', '');
      if (submitBtn) submitBtn.disabled = false;
      if (orderGroup) orderGroup.removeAttribute('hidden');
      if (channel) {
        setProductVisible(true);
      } else {
        setProductVisible(false);
      }
      setOrderFieldState();
    }

    function clearOrderError() {
      if (orderError) {
        orderError.textContent = '';
        orderError.hidden = true;
      }
      orderInput.removeAttribute('aria-invalid');
    }

    function clearFeedback() {
      if (!feedback) return;
      feedback.textContent = '';
      feedback.hidden = true;
      feedback.classList.remove('rwf-form-feedback--success', 'rwf-form-feedback--error');
    }

    function showFeedback(message, kind) {
      if (!feedback) return;
      feedback.textContent = message;
      feedback.hidden = false;
      feedback.classList.remove('rwf-form-feedback--success', 'rwf-form-feedback--error');
      feedback.classList.add(
        kind === 'success' ? 'rwf-form-feedback--success' : 'rwf-form-feedback--error'
      );
    }

    function validateOrderId() {
      var channel = purchaseSelect.value;
      var raw = orderInput.value;
      clearOrderError();

      if (!channel) {
        return true;
      }

      if (!ORDER_ID_RULES[channel]) {
        return true;
      }

      if (channel === 'Amazon') {
        orderInput.value = formatAmazonOrderId(orderInput.value);
      } else if (channel === 'FURIDEN Website') {
        var fur = normalizeFuridenOrderId(orderInput.value);
        if (fur) orderInput.value = fur;
      }

      raw = orderInput.value;

      if (!raw.trim()) {
        if (orderError) {
          orderError.textContent = 'Please enter your Order ID.';
          orderError.hidden = false;
        }
        orderInput.setAttribute('aria-invalid', 'true');
        orderInput.focus();
        return false;
      }

      var rule = ORDER_ID_RULES[channel];
      if (rule.test(raw.trim())) {
        return true;
      }

      if (orderError) {
        orderError.textContent = rule.message;
        orderError.hidden = false;
      }
      orderInput.setAttribute('aria-invalid', 'true');
      orderInput.focus();
      return false;
    }

    function finishSubmit() {
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.classList.remove('rwf-submit--loading');
        submitBtn.removeAttribute('aria-busy');
      }
    }

    /**
     * 与 DevTools 中一致：GET post-json?u=…&id=…&f_id=…&c=回调名&EMAIL=…&subscribe=Subscribe&_=时间戳…
     * 由 <script> 加载（sec-fetch-dest: script），非 fetch，无 CORS。
     */
    function submitMailchimpJsonp() {
      clearFeedback();

      var hiddenUnderscore = form.querySelector('input[name="_"]');
      if (hiddenUnderscore) {
        hiddenUnderscore.value = String(Date.now());
      }

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.classList.add('rwf-submit--loading');
        submitBtn.setAttribute('aria-busy', 'true');
      }

      var callbackName = 'mailchimpJsonp_' + Date.now() + '_' + Math.floor(Math.random() * 1e9);
      var scriptEl = document.createElement('script');
      var timeoutId;

      function cleanup() {
        if (timeoutId) {
          clearTimeout(timeoutId);
          timeoutId = null;
        }
        try {
          delete window[callbackName];
        } catch (e) {
          window[callbackName] = undefined;
        }
        if (scriptEl.parentNode) {
          scriptEl.parentNode.removeChild(scriptEl);
        }
        finishSubmit();
      }

      window[callbackName] = function (data) {
        cleanup();
        if (!data || typeof data !== 'object') {
          showFeedback(
            'We could not read the server response. Please try again.',
            'error'
          );
          return;
        }
        if (data.result === 'success') {
          showFeedback(data.msg || 'Thank you!', 'success');
          form.reset();
          syncPurchaseChannelUi();
          clearOrderError();
        } else {
          showFeedback(
            data.msg || 'Something went wrong. Please try again.',
            'error'
          );
        }
      };

      var params = new URLSearchParams(new FormData(form));
      params.set('c', callbackName);

      var baseUrl = form.getAttribute('action') || MAILCHIMP_POST_JSON;
      var join = baseUrl.indexOf('?') === -1 ? '?' : '&';
      scriptEl.src = baseUrl + join + params.toString();
      scriptEl.async = true;
      scriptEl.onerror = function () {
        cleanup();
        showFeedback(
          'Unable to load the subscription service. Please try again.',
          'error'
        );
      };

      timeoutId = setTimeout(function () {
        if (window[callbackName]) {
          cleanup();
          showFeedback('Request timed out. Please try again.', 'error');
        }
      }, 60000);

      document.body.appendChild(scriptEl);
    }

    purchaseSelect.addEventListener('change', syncPurchaseChannelUi);

    orderInput.addEventListener('input', function () {
      clearOrderError();
      if (purchaseSelect.value === 'Amazon') {
        var formatted = formatAmazonOrderId(orderInput.value);
        if (formatted !== orderInput.value) {
          orderInput.value = formatted;
          var len = formatted.length;
          orderInput.setSelectionRange(len, len);
        }
      }
    });

    orderInput.addEventListener('blur', function () {
      if (purchaseSelect.value === 'Amazon') {
        orderInput.value = formatAmazonOrderId(orderInput.value);
      } else if (purchaseSelect.value === 'FURIDEN Website') {
        var n = normalizeFuridenOrderId(orderInput.value);
        if (n) orderInput.value = n;
      }
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      if (isBlockedSubmitChannel(purchaseSelect.value)) {
        if (blockedHint) {
          blockedHint.removeAttribute('hidden');
          blockedHint.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        }
        return;
      }

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      if (!validateOrderId()) {
        return;
      }

      submitMailchimpJsonp();
    });

    syncPurchaseChannelUi();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
